export const dictionaryEntryDisplayMixin = {
  props: {
    shortformPlaceholder: { default: '' },
    shortformPlaceholderProfile: { default: '' }
  },
  computed: {
    placeholderChar () {
      return this.placeholderForView(this.shortformPlaceholder)
    }
  },
  methods: {
    isNotationEntry (entry) {
      return entry && (entry.type === 'star' || entry.type === 'pair')
    },
    isNeutralEntry (entry) {
      return entry && entry.type === 'neut'
    },
    shortFormLabel (type, shortformPlaceholderKey) {
      if (type === 'neut') return ''
      if (type === 'pair') return 'pair'
      const key = this.shortformPlaceholderProfile || shortformPlaceholderKey
      if (!key || !String(key).trim()) return 'star'
      return key
    },
    placeholderForView (shortformPlaceholderKey) {
      const key = this.shortformPlaceholderProfile || shortformPlaceholderKey
      if (key === 'star') return '*'
      if (key === 'colon') return ':'
      if (key === 'lowdash') return '_'
      if (key === 'slash') return '/-'
      return '*'
    },
    alternativeSectionLabel (entry) {
      if (!entry) return ''
      if (this.isNeutralEntry(entry)) {
        return this.$t('dict.neutral_label')
      }
      if (entry.type === 'pair') {
        return this.$t('dict.notation_label_pair')
      }
      const labelKey = this.shortFormLabel(entry.type, this.shortformPlaceholder)
      return this.$t('dict.notation_label_shortform', { form: this.$t(labelKey) })
    },
    entryMetaTitle (entry) {
      if (!entry || (!entry.editor && !entry.edit_date)) return ''
      return `${entry.editor || ''} · ${entry.edit_date || ''}`.trim()
    }
  }
}
